const spdata_2021 = [
  {
    Roll: "16BEC025",
    Name: "Chaudhary vaisvikkumar rameshbhai",
    Company: "In house",
  },
  {
    Roll: "16BEC050",
    Name: "Jadav shubhamkumar vallavbhai",
    Company: "In house",
  },
  { Roll: "17BEC001", Name: "Aagam dharmesh jariwala", Company: "In house" },
  { Roll: "17BEC002", Name: "Abhay  sharma", Company: "Vandaxo" },
  { Roll: "17BEC003", Name: "Aditya  jain", Company: "In house" },
  { Roll: "17BEC004", Name: "Adodariya kashyap popatbhai", Company: "Allagi" },
  { Roll: "17BEC005", Name: "Agrini chaturvedi", Company: "Vandaxo" },
  { Roll: "17BEC006", Name: "Ahir aditya rameshbhai", Company: "Embee" },
  {
    Roll: "17BEC007",
    Name: "Airan shruti atulkumar",
    Company: "Komoline aerospace",
  },
  { Roll: "17BEC008", Name: "Akshay  mishra", Company: "Vandaxo" },
  {
    Roll: "17BEC009",
    Name: "Aman rajkumar kshatriya",
    Company: "Komoline aerospace",
  },
  { Roll: "17BEC010", Name: "Anant  raina", Company: "Nhance dynamics" },
  { Roll: "17BEC011", Name: "Asmita asim kumar barik", Company: "Soleos" },
  { Roll: "17BEC013", Name: "Ayushee  samridhi", Company: "E infochips" },
  {
    Roll: "17BEC014",
    Name: "Baraiya dhavalkumar kamleshbhai",
    Company: "Darillighting",
  },
  {
    Roll: "17BEC015",
    Name: "Bhanushali meetkumar vasantbhai",
    Company: "Nesaa",
  },
  { Roll: "17BEC016", Name: "Bhargava arpita sandeep", Company: "Allagi" },
  { Roll: "17BEC017", Name: "Bhavin  patel", Company: "Allagi" },
  {
    Roll: "17BEC018",
    Name: "Bhavsar nirjhari jayvadan",
    Company: "Gvk emergency management and research institute ",
  },
  { Roll: "17BEC019", Name: "Bhensdadiya kevin prabhulal", Company: "Allagi" },
  { Roll: "17BEC020", Name: "Bohra rohan jagdish", Company: "In house" },
  { Roll: "17BEC022", Name: "Chinmay  khurana", Company: "In house" },
  { Roll: "17BEC023", Name: "Desai sapan nikunj", Company: "Vandaxo" },
  { Roll: "17BEC024", Name: "Devansh  chawla", Company: "Allagi" },
  { Roll: "17BEC025", Name: "Dholakia himanshu rajeshkumar", Company: "Ibm" },
  { Roll: "17BEC026", Name: "Dhwani rakesh malkan", Company: "Edgeneural" },
  { Roll: "17BEC027", Name: "Divyesh kalpeshkumar sankhla", Company: "Embee" },
  { Roll: "17BEC028", Name: "Dobariya priti bharatbhai", Company: "Soleos" },
  {
    Roll: "17BEC029",
    Name: "Gajjar devanshu sanjeevkumar",
    Company: "Moba mobile automation ",
  },
  { Roll: "17BEC030", Name: "Gangwani gunjan mukesh", Company: "Upna spain" },
  {
    Roll: "17BEC031",
    Name: "Gautam rashi rajesh",
    Company: "Genus electrotech lmt.",
  },
  { Roll: "17BEC032", Name: "Gurmeet jasvir khurana", Company: "Fuaark" },
  { Roll: "17BEC034", Name: "Hetanshu  gupta", Company: "Vandaxo" },
  { Roll: "17BEC035", Name: "Honey nikhil shah", Company: "E infochips" },
  { Roll: "17BEC036", Name: "Jagrat jhamb", Company: "Vandaxo" },
  { Roll: "17BEC037", Name: "Jain dhruv vinodkumar", Company: "Ineuron" },
  { Roll: "17BEC038", Name: "Jain khushi purvesh", Company: "Iit kanpur" },
  {
    Roll: "17BEC039",
    Name: "Jaykumar prafulbhai domadiya",
    Company: "E infochips",
  },
  { Roll: "17BEC040", Name: "Jeswani aman jagdish", Company: "In house" },
  { Roll: "17BEC041", Name: "Jahnavi jha", Company: "Allagi" },
  { Roll: "17BEC042", Name: "Jigyasa  mahur", Company: "Vandaxo" },
  { Roll: "17BEC043", Name: "Jyotika  gurnani", Company: "Komoline aerospace" },
  { Roll: "17BEC045", Name: "Kapadia karan maulik", Company: "Allagi" },
  { Roll: "17BEC046", Name: "Kartik  jain", Company: "Allagi" },
  { Roll: "17BEC047", Name: "Kartik madhukeshwar hegde", Company: "Vandaxo" },
  { Roll: "17BEC048", Name: "Keshav dinesh kasat", Company: "Finance" },
  { Roll: "17BEC049", Name: "Kunwar vaibhav  ", Company: "Upna spain" },
  { Roll: "17BEC050", Name: "Kv sai akhilesh", Company: "Lab systems " },
  { Roll: "17BEC051", Name: "Makwana shubham sandipbhai", Company: "Allagi" },
  { Roll: "17BEC052", Name: "Malhotra rohan manish", Company: "Allagi" },
  { Roll: "17BEC053", Name: "Meet singh chauhan", Company: "Embee" },
  {
    Roll: "17BEC054",
    Name: "Miglani manan sunil",
    Company: "Komoline aerospace",
  },
  { Roll: "17BEC055", Name: "Mishra rajiv sushil", Company: "Embee" },
  { Roll: "17BEC056", Name: "Naidu hema dinesh", Company: "Allagi" },
  { Roll: "17BEC057", Name: "Naik meet dipakbhai", Company: "Akshini systems" },
  {
    Roll: "17BEC058",
    Name: "Navadiya pratikkumar mukeshbhai",
    Company: "E infochips",
  },
  { Roll: "17BEC059", Name: "Nishith ranabhai poshiya", Company: "Allagi" },
  { Roll: "17BEC060", Name: "Padiya jeel rajesh", Company: "Allagi" },
  { Roll: "17BEC061", Name: "Pahal chhapiya", Company: "Akshini systems" },
  { Roll: "17BEC062", Name: "Parghi anandi chandulal", Company: "Nesaa" },
  { Roll: "17BEC063", Name: "Parikh tirth keyurkumar", Company: "Allagi" },
  { Roll: "17BEC064", Name: "Patel deep hiteshbhai", Company: "In house" },
  {
    Roll: "17BEC065",
    Name: "Patel hemang harishbhai",
    Company: "Akshini systems",
  },
  {
    Roll: "17BEC066",
    Name: "Patel mansi amishkumar",
    Company: "Komoline aerospace",
  },
  {
    Roll: "17BEC067",
    Name: "Patel mosam mukeshbhai",
    Company: "Fossee fellowship, iit bombay",
  },
  {
    Roll: "17BEC068",
    Name: "Patel nikhilkumar pareshbhai",
    Company: "Nhance dynamics",
  },
  { Roll: "17BEC069", Name: "Patel pratyusha", Company: "Vandaxo" },
  { Roll: "17BEC070", Name: "Patel yashkumar girishkumar", Company: "Allagi" },
  { Roll: "17BEC071", Name: "Prajapati kush bharatkumar", Company: "Vandaxo" },
  { Roll: "17BEC072", Name: "Pranshu jain  ", Company: "Bsnl" },
  { Roll: "17BEC073", Name: "Praveen  kukreja", Company: "Wehear" },
  {
    Roll: "17BEC074",
    Name: "Pravishty  maheshwari",
    Company: "Adani power ltd.",
  },
  { Roll: "17BEC075", Name: "Priyam  patel", Company: "E infochips" },
  { Roll: "17BEC076", Name: "Pujara deep dhavalbhai", Company: "Upna spain" },
  { Roll: "17BEC077", Name: "Rajat  goyal", Company: "E infochips" },
  {
    Roll: "17BEC078",
    Name: "Rakholiya abhishek amarutkumar",
    Company: "Allagi",
  },
  { Roll: "17BEC079", Name: "Rakkshab varadharajan iyer", Company: "Lumeo" },
  { Roll: "17BEC080", Name: "Ramani vatsal pravinbhai", Company: "Allagi" },
  { Roll: "17BEC081", Name: "Ramika  chakhaiyar", Company: "E infochips" },
  { Roll: "17BEC082", Name: "Risha  singh", Company: "E infochips" },
  { Roll: "17BEC083", Name: "Rishabh  khabya", Company: "Soleos" },
  { Roll: "17BEC084", Name: "Rishabh  sharma", Company: "Allagi" },
  {
    Roll: "17BEC085",
    Name: "Rishabh hiren patadia",
    Company: "Nysha solutions",
  },
  { Roll: "17BEC086", Name: "Rishi mehul pandya", Company: "Swift auxi tech" },
  { Roll: "17BEC087", Name: "Rishiraj singh rathore", Company: "Embee" },
  { Roll: "17BEC088", Name: "Rohan  gupta", Company: "Soleos" },
  { Roll: "17BEC089", Name: "Rohan kumar patel", Company: "Vandaxo" },
  { Roll: "17BEC091", Name: "Sagar ashok maheshwari", Company: "Lumeo" },
  { Roll: "17BEC092", Name: "Sagar biren patel", Company: "E infochips" },
  { Roll: "17BEC093", Name: "Sahil  tulsiani", Company: "Vandaxo" },
  { Roll: "17BEC094", Name: "Sameer  ravi kanth", Company: "Embee" },
  { Roll: "17BEC095", Name: "Saumya  borwankar", Company: "Sunflowee biztech" },
  {
    Roll: "17BEC096",
    Name: "Saurav kiritbhai dekhtawala",
    Company: "In house",
  },
  { Roll: "17BEC097", Name: "Shah dhruv milan", Company: "Soleos" },
  { Roll: "17BEC098", Name: "Shah hiral nayan", Company: "Allagi" },
  { Roll: "17BEC099", Name: "Shah jainam nileshbhai", Company: "Allagi" },
  { Roll: "17BEC100", Name: "Shah ruchit bankimbhai", Company: "Allagi" },
  { Roll: "17BEC101", Name: "Shah samyak pranavbhai", Company: "Sunrobotrics" },
  { Roll: "17BEC102", Name: "Shah udit tejas", Company: "Soleos" },
  {
    Roll: "17BEC103",
    Name: "Shaikh rehan alam shahnawaz alam",
    Company: "E infochips",
  },
  { Roll: "17BEC104", Name: "Sharma devang yogesh", Company: "Ibm" },
  {
    Roll: "17BEC105",
    Name: "Sharma himanshu govardhan",
    Company: "E infochips",
  },
  {
    Roll: "17BEC106",
    Name: "Shivangi manish shah",
    Company: "Servilink system ",
  },
  { Roll: "17BEC108", Name: "Shraddha  pandey", Company: "Appsecco" },
  { Roll: "17BEC109", Name: "Shrey bhatnagar", Company: "Ibm" },
  { Roll: "17BEC110", Name: "Shreya chandrasekhar", Company: "Robokits india" },
  { Roll: "17BEC111", Name: "Shruti  goel", Company: "In house" },
  { Roll: "17BEC112", Name: "Shwet mitesh shah", Company: "Allagi" },
  { Roll: "17BEC113", Name: "Soma aditya mahesh", Company: "In house" },
  { Roll: "17BEC116", Name: "Tarun kishore khilani", Company: "Myriadcara" },
  { Roll: "17BEC117", Name: "Thaker poojan shaileshhai", Company: "In house" },
  {
    Roll: "17BEC118",
    Name: "Thakor vaibhavkumar jigneshkumar",
    Company: "Nhance dynamics",
  },
  { Roll: "17BEC119", Name: "Tripathi surbhi niteshbhai", Company: "Vandaxo" },
  {
    Roll: "17BEC120",
    Name: "Trivedi jay divyakant",
    Company: "Hello skate mobility",
  },
  {
    Roll: "17BEC121",
    Name: "Upadhyay shivanshu rajiv kumar",
    Company: "Vandaxo",
  },
  {
    Roll: "17BEC122",
    Name: "Vaghani darshankumar nareshbhai",
    Company: "Embee",
  },
  {
    Roll: "17BEC124",
    Name: "Vaidya gargee hemantkumar",
    Company: "Robokits india",
  },
  { Roll: "17BEC126", Name: "Vatsal  jain", Company: "Hexco global,usa,llc" },
  { Roll: "17BEC127", Name: "Yash deepak shamnani", Company: "In house" },
  {
    Roll: "17BEC151",
    Name: "Bhatnagar siddhant vinod",
    Company: "Vayve technologies",
  },
  {
    Roll: "18BEC151",
    Name: "Goradiya vatsal akshaybhai",
    Company: "Darillighting",
  },
  {
    Roll: "18BEC152",
    Name: "Parmar kajalben natvarbhai",
    Company: "Texpro solutions ",
  },
];

export default spdata_2021;
